// removed by extract-text-webpack-plugin
module.exports = {"appHeader":"_-src-components-CategoryList-index---appHeader---1zMv9","title":"_-src-components-CategoryList-index---title---3fyYM","listHeader":"_-src-components-CategoryList-index---listHeader---3JR2P","addNewButton":"_-src-components-CategoryList-index---addNewButton---3cuiL","icon":"_-src-components-CategoryList-index---icon---3WhJx","content":"_-src-components-CategoryList-index---content---3eWDZ","loader":"_-src-components-CategoryList-index---loader---2uCkG","draggable":"_-src-components-CategoryList-index---draggable---29mJ2"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CategoryList/index.css
// module id = 657
// module chunks = 1